import { SystemUser } from '@libs/models/common';
import { applyTenantId, request } from '../request';

export function login(email: string, tenantId?: string) {
  let requestToCall = applyTenantId(tenantId);
  return requestToCall.get('/v2/identity/login-otp', {
    params: {
      email,
    },
  });
}

export async function getUserInfo(): Promise<SystemUser> {
  const response = await request.get<SystemUser>('/v2/identity/info');
  return response.data;
}
